import React from 'react';

const Settings: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="bg-white shadow-lg rounded-2xl overflow-hidden">
        {/* Header */}
        <div className="px-6 py-4 border-b border-gray-200">
          <h1 className="text-2xl font-bold text-gray-900">ການຕັ້ງຄ່າ</h1>
          <p className="mt-1 text-sm text-gray-600">ຈັດການການຕັ້ງຄ່າຂອງທ່ານ</p>
        </div>

        {/* Empty Content */}
        <div className="px-6 py-8 text-center">
          <p className="text-gray-500">ບໍ່ມີການຕັ້ງຄ່າໃດໆ</p>
        </div>
      </div>
    </div>
  );
};

export default Settings; 